import { render } from "./UploadResourceIcon.vue?vue&type=template&id=889eda12&scoped=true"
import script from "./UploadResourceIcon.vue?vue&type=script&lang=js"
export * from "./UploadResourceIcon.vue?vue&type=script&lang=js"

import "./UploadResourceIcon.vue?vue&type=style&index=0&id=889eda12&lang=less&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-889eda12"]])

export default __exports__